import MuiBox from '@new-components/atoms/MuiBox';
import MuiLink from '@new-components/atoms/MuiLink';
import MuiTypography from '@new-components/atoms/MuiTypography';
import MuiBreadcrumbs from '@new-components/atoms/MuiBreadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import {DEFAULT_LABEL, LABEL} from './constants';
import ReactHtmlParser from '@libs/reactHtmlParser';

export type BreadcrumbItem = {
  label: string;
  url?: string;
};
type Props = {
  /**
   * The primary text to be displayed, typically as the heading or main label.
   */
  label?: string;
  /**
   * Breadcrumb data as an array of items.
   */
  breadcrumbs: BreadcrumbItem[];
};

const RegisterInterestInfo = (props: Props) => {
  const renderBreadcrumbs = () => {
    return (
      <MuiBreadcrumbs
        maxItems={2}
        separator={<NavigateNextIcon fontSize='small' />}
        sx={{fontSize: '15px', fontWeight: 400, letterSpacing: '-0.4px'}}>
        {props.breadcrumbs &&
          props.breadcrumbs.map((item, index) => {
            const isLast = index === props.breadcrumbs.length - 1;
            return isLast ? (
              <MuiTypography key={index} sx={{color: '#EB6924', opacity: 0.7}}>
                {item.label}
              </MuiTypography>
            ) : (
              <MuiLink
                key={index}
                href={item.url || ''}
                sx={{
                  'color': '#82807E',
                  'textDecoration': 'none',
                  'transition': 'color 0.3s, transform 0.3s',
                  '&:hover': {
                    color: '#EB6924',
                    opacity: 0.7,
                    transform: 'scale(1.05)',
                  },
                }}>
                {item.label}
              </MuiLink>
            );
          })}
      </MuiBreadcrumbs>
    );
  };

  return (
    <MuiBox>
      {props.breadcrumbs.length > 0 ? (
        <>
          <MuiTypography
            sx={{
              paddingBottom: '4px',
              fontSize: '17px',
              fontWeight: 400,
              letterSpacing: '-0.4px',
            }}>
            {props.label ? ReactHtmlParser(props.label) : LABEL}
          </MuiTypography>
          {renderBreadcrumbs()}
        </>
      ) : (
        <MuiTypography
          sx={{fontSize: '17px', fontWeight: 400, letterSpacing: '-0.4px'}}>
          {props.label ? ReactHtmlParser(props.label) : DEFAULT_LABEL}
        </MuiTypography>
      )}
    </MuiBox>
  );
};

export default RegisterInterestInfo;
